/* tslint:disable */
const en = {
    validation: {
        validation_required: '{key} is required',
        validation_string: '{key} needs to be a string',
        validation_int: '{key} needs to be a number',
        validation_date: '{key} needs to be a date',
        fields: {
            insight: 'Question',
            todo: 'Notes',
            responsible: 'Responsible Person',
            contacttill: 'Due date',
            topics: 'Topics',
        },
    },
    errors: {
        validation: {
            nameOrTenant: "Company or First-/Surname are required",
            title: 'Please enter a title',
            description: 'Please enter a description',
            dynamic_field: 'Please enter a title',
            name: 'Please enter a name',
            email: 'Please enter a valid email',
            emailTaken: 'This e-mail address is already in use',
            password: 'Please enter a valid password',
            passwordIsIncorrect: 'Current typed password is incorrect',
            currentPassword: 'Please enter the current password',
            shortPassword: 'The password must be at least 8 characters long',
            firstName: 'Please enter your first name',
            lastName: 'Please enter your last name',
            shortFirstNameOrLastName: 'The firstname / lastname must be at least two characters long',
            bkp: 'Please enter a trade number',
            abbreviation: 'Please enter a Abbreviation',
            order: 'Please enter a Sorting number',
            lesson: 'Please enter a lesson',
            phase: 'Please select a phase',
            pmphase: 'Please select a project management phase',
            trade: 'Please select a trade',
            topic: 'Please select a topic',
            subphase: 'Please select a Subphase',
            team: 'Please select a team member',
            verificationCode: 'Please enter the verification code',
            duplicateTitle: 'This project name is already used in this company',
            problem: 'Please enter a problem',
            solution: 'Please enter a solution',
            topicAndInsightNeeded: 'You must define a new question and select a corresponding topic',
            address: 'Please enter an address',
            postcode: 'Please enter a ZIP code',
            city: 'Please enter a city',
            country: 'Please enter a country',
            useNumericValue: 'Please use a numeric value',
            phone: 'Please enter a phone number',
        },
        server: {
            invalidVerificationCode: 'The Verification code is not valid!',
            invalidToken: 'Invalid Token',
            invalidFileType: 'There was an error while uploading the image.\nit could probably be caused by your connection, or invalid file extension.\nThe image must be a file of type: jpeg, png, jpg, gif, svg.',
            failedToLoadCalendar: 'Failed to load calendar data. Please try again later.',
        },
        no_entries_found: 'No entries found',
    },
    keywords: {
        tenant: 'Company',
        notes: 'Notes',
        todo: 'Todo',
        checked_by_user: 'Checked by',
        needscheck: 'Check?',
        check: 'Check',
        error: 'Error',
        worksheetAbbr: 'WS',
        IC: 'IC',
        CK: 'CK',
        yes: 'Yes',
        no: 'No',
        and: 'and',
        or: 'or',
        show: 'Show',
        empty: 'empty',
        select: 'Select',
        save: 'Save',
        update: 'Update',
        remove: 'Remove',
        delete: 'Delete',
        enable: 'Enable',
        enabled: 'Enabled',
        disable: 'Disable',
        disabled: 'Disabled',
        clear: 'Clear',
        back: 'Back',
        cancel: 'Cancel',
        close: 'Close',
        logout: 'Logout',
        login: 'Login',
        register: 'Sign up',
        title: 'Title',
        account: 'Account',
        myAccount: 'My Account',
        notification: 'Notification | Notifications',
        subscription: 'Subscription',
        settings: 'Settings',
        privacy: 'Privacy',
        email: 'Email',
        password: 'Password',
        new: 'New',
        newProject: 'New Project',
        editProject: 'Edit Project',
        deleteProject: 'Delete Project',
        description: 'Description',
        firstname: 'First name',
        lastname: 'Last name',
        at: '',
        actions: 'Actions',
        creator: 'Creator',
        search: 'Search',
        send: 'Send',
        confirm: 'Confirm',
        edit: 'Edit',
        private: 'Private',
        users: 'Users',
        phone: 'Phone',
        add: 'Add',
        address: 'Address',
        additionalAddress: 'Additional Address',
        postcode: 'Postcode',
        place: 'City',
        country: 'Country',
        order: 'Order',
        abbreviation: 'Abbreviation',
        name: 'Name',
        income: 'Income',
        perMonth: 'Per month',
        perYear: 'Per year',
        calendar: 'Calendar',
        copy: 'Copy',
        copied: 'Copied',
        all: 'All',
        question: 'Question | Questions',
        cloning: 'Cloning',
        knowledge: 'Knowledge',
        project: 'Project | Projects',
        worksheet: 'Worksheet',
        worksheets: 'Worksheets',
        trade: 'Trade | Trades',
        topic: 'Topic | Topics',
        tradesTopics: 'Trades topics',
        phasesforTrades: 'Phases for Trades',
        phase: 'Phase',
        phases: 'Phases',
        tradesPhases: 'Trades Phases',
        subPhase: 'Subphase',
        projectManagement: 'Project Management',
        experience: 'Experience',
        experiences: 'Experiences',
        lesson: 'Lesson | Lessons',
        problem: 'Challenge',
        possibleSolution: 'Possible question',
        lessonsFor: 'Lessons for',
        responsible: 'Responsible',
        reports: 'Todo',
        company: 'Company | Companies',
        accepting: 'Accepting',
        contacttill: 'Due Date',
        solution: 'Notes', // changed by Chris request on 15.03.2021 11:31
        checked: 'Checked',
        checkedBy: 'Checked by',
        contactEmail: 'Contact E-Mail',
        allPhases: 'All Phases',
        appliedLessons: 'Applied lessons',
        teamMembers: 'Team members',
        concept: 'Global Topic | Global Topics',
        pmConcept: 'Global Sub Phase | Global Sub Phases',
        conceptTitle: 'Global Topic title',
        done: 'Done',
        print: 'Print',
        weekly: 'Weekly',
        biweekly: 'Biweekly',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        inspectionCheckList: 'Inspection checklist',
        tag: 'Tag | Tags',
        default: 'Default',
        feature: 'Feature | Features',
        filteringSetting: 'Filtering setting',
        filter: 'Filter',
        allTags: 'All Tags',
        allPMSubPhases: 'All Subphases',
        reset: 'Reset',
        newTag: 'New Tag',
        structure: 'Structure | Structures',
        newRisk: 'New Risk',
        risk: 'Risk',
        color: 'Color',
        noColor: 'No Color',
        newDynamicField: 'New Attribute',
        dynamicField: 'Attribute | Attributes',
        dynamicFieldInWorksheet: 'Attributes in worksheets',
        dynamicFieldName: 'Attribute name',
        msIntegration: 'Microsoft Teams And Planner',
        updateDynamicField: 'Update Attribute',
        export: 'Export',
        moreInfo: 'More Info',
        insight: 'Insight',
        integration: 'Integration | Integrations',
        maximize: 'Maximize',
        disconnect: 'Disconnect',
        connect: 'Connect',
        tab: 'Tab',
        include: 'Include',
        finish: 'Finish',
        value: 'Value',
        cost: 'Cost (CHF)',
        probability: 'Probability (%)',
        impact: 'Impact (CHF)',
    },
    print: {
        trade: 'Trade | Trades',
        phase: 'Phase',
        todo: 'Todo',
        insight: 'Insight',
        solution: 'Notes',
        responsible: 'Responsible',
        contacttill: 'Due Date',
        done: 'Done',
        needscheck: 'Check?',
        checked: 'Checked',
        checked_by_user: 'Checked by',
        cost: 'Cost (CHF)<br>(K)',
        probability: 'Probability (%)<br>(W)',
        impact: 'Impact (CHF)<br>(R/{divider}) x K x W',
    },
    labels: {
        inheritedProject: 'Inherited Project',
        parentLesson: 'Parent Lesson',
        noParentLessons: 'No lessons available',
        msTeamsAndPlanner: 'Microsoft Teams and Planner (Only trades and project management)',
        projectOnly: 'Visible only to you and the other members of the project team',
        myLessons: 'Show my lessons',
        projectManagementPhases: 'Project Management Phases',
        pMPhase: 'PM Phases',
        otherTeamMembers: 'Other AppEx users',
        externalTeamMembers: 'External team members (without AppEx license)',
        msUsers: 'Microsoft Users',
        newWorksheet: 'New Worksheet',
        updateWorksheet: 'Update Worksheet',
        lessonFor: 'Lesson for',
        addNewLesson: 'Add a new lesson',
        loginOut: 'Logging out',
        passwordForgotten: 'Forgot password?',
        newKnowledge: 'New Knowledge',
        notifications: 'Notifications',
        youAreJoining: 'You are joining',
        newProject: 'New Project',
        updateProject: 'Update Project',
        newTopic: 'New Topic',
        updateTopic: 'Update Topic',
        newTrade: 'New Trade',
        updateTrade: 'Update Trade',
        newPhase: 'New Phase',
        updatePhase: 'Update Phase',
        newSubPhase: 'New Subphase',
        updateSubPhase: 'Update Subphase',
        updateAt: 'Updated at',
        changedBy: 'Changed by',
        addNewQuestion: 'Add a new question',
        searchInLessons: 'Search in lessons',
        passwordRecovery: 'Password recovery',
        resetPassword: 'Reset password',
        changePassword: 'Change password',
        verificationCode: 'Verification Code',
        ResendVerificationEmail: 'Resend verification email',
        privateLessons: 'Private Lessons',
        FilterSubphasesAndLessons: 'Filter subphases and lessons',
        filterResolved: 'Show completed activities',
        showEverything: 'Show everything',
        mandatoryLesson: 'Does this lesson always have to be selected in a worksheet?',
        lessonAsQuestion: 'Lesson Worded as a Question',
        createALesson: 'Create a Lesson',
        selectAll: 'Select All',
        createWorksheet: 'Create Worksheet',
        newPrivateLessonFor: 'New Private Lesson For',
        newLesson: 'New Lesson',
        editLesson: 'Edit Lesson',
        memberSince: 'Member since',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmEmail: 'Confirm Email',
        editAccount: 'Edit Account',
        calendarTutorial: 'How to subscribe to your calendar',
        calendarTutorialOutlook: 'Outlook',
        calendarTutorialOutlookInstructions: 'In Outlook, go to the Calendar, select "Add Calendar" and then "From Web". Paste the copied link there.',
        calendarTutorialGoogle: 'Google Calendar',
        calendarTutorialGoogleInstructions: 'In Google Calendar, click the "+" next to "Other calendars" and select "From URL". Paste the copied link there.',
        calendarTutorialApple: 'Apple Calendar',
        calendarTutorialAppleInstructions: 'In Apple Calendar, go to "File" > "New Calendar Subscription...". Paste the copied link there.',
        calendarDescription: 'Here you can find your personal calendar feeds for your tasks.',
        calendarLanguageSelection: 'Calendar link in another language',
        accountDetails: 'Account details',
        noLessons: 'No lessons',
        noLessonsInThisWorksheet: 'There have not been any lessons created for this worksheet',
        noLessonsToCheck: 'No lessons to check',
        noLessonsHaveBeenSelectedToCheck: 'There were not any lessons selected to be checked',
        welcomeToAppex: 'Welcome to Appex',
        howDoesAppexWork: 'How does Appex work?',
        insightPlaceholder: 'Question to answer',
        actionNeeded: 'Is action required?',
        needsCheck: 'Check?',
        noActionNeededTitle: 'No action needed items',
        noActionNeededBody: 'Currently there are no applied lessons which require action',
        projectSpecificQuestions: 'Project specific questions',
        newQuestion: 'New Question',
        enterDate: 'Please choose a date',
        projectSpecificLesson: 'New project-specific question (will be saved as a lesson for this project)',
        projectSpecificQuestion: 'New project-specific question',
        updateProjectSpecificQuestion: 'Update project-specific question',
        noLessonCreatedTitle: 'No lessons created',
        noLessonCreatedBody: 'Please add a lesson first',
        newCompany: 'Create new company',
        updateCompany: 'Update company',
        amountOfLessons: 'Number of lessons',
        sendInvitation: 'Send invitation',
        cloneData: 'Clone data',
        clonedData: 'Cloned data',
        addNewPrivateLesson: 'Add a new private lesson',
        editWorksheet: 'Adapt worksheet',
        enableSynchronisation: 'Should the synchronisation be enabled',
        showEmptyTopics: 'Show empty topics',
        showEmptySubphases: 'Show empty subphases',
        showEmptyTrades: 'Show empty trades',
        assignAllDataToUser: 'Assign all data to',
        deleteAllData: 'Delete all data',
        promoteToAdmin: 'Change to Admin',
        demoteToUser: 'Change to User',
        displayColumns: 'Display columns',
        receiveEmailNotifications: 'Receive email alerts to add new challenges',
        lastOnline: 'Last Online',
        phaseDescription: 'What is this phase about?',
        orderExplanation: 'Sorting (e.g Number 1 - 100)',
        lessonLink: 'Link',
        lessonSolution: 'Solution',
        moreInformation: 'More Information',
        tooltips: {
            hbButton: 'Show worksheet',
            prButton: 'Display inspection checklist',
            newWorksheetFor: 'Create a new worksheet for {0}',
        },
        featureDynamicTab: 'Enable x tab',
        newTag: 'Create new tag',
        updateTag: 'Update tag',
        saveProjectToAddExternalTeamMember: 'Project must be saved first.',
        addExternalTeamMember: 'Add External team members',
        manageExternalTeamMember: 'Manage External team members',
        personalTasks: 'Individual Tasks',
        openTasks: 'Open Tasks',
        doneTasks: 'Completed Tasks',
        allTasks: 'All Tasks',
        nonCheckedChecks: 'Not Checked',
        checkedChecks: 'Checked',
        allNeedChecks: 'To Check',
        allChecks: 'All',
        sendEmail: 'Send E-Mail',
        uploadLogo: 'Upload Logo',
        selectLogo: 'Select Logo',
        selectLogoCrop: 'Select Selection',
        deleteLogo: 'Delete Logo',
        addToKnowledgeBase: 'Propose for knowledge database',
        irreversibleAction: 'This is a <span class="has-text-weight-semibold is-uppercase has-text-danger">irreversible action!</span>',
        editInKnowledgeTab: 'Can only be edited in knowledge',
        showUnread: 'Show only unread notifications',
        markAsRead: 'Mark as read',
        markAllAsRead: 'Mark all as read',
        loadMore: 'Load more',
        noUnreadLeft: 'No unread notifications left',
        tabTitle: 'Tab title',
        lessonTitle: 'Lesson title',
        processTitle: 'Process title',
        subProcessTitle: 'Sub process title',
        dynamicTab: 'Dynamic Tab',
        createdBy: 'Created by',
        createdAt: 'Created at',
        byParentProject: 'Inherited from parent project',
    },
    placeholder: {
        projectTitle: 'Project title',
        projectDescription: 'Project description',
        teamMember: 'Select a team member',
        selectExternalTeamMember: 'Select a External team member',
        selectAUser: 'Choose a User',
        selectAnAction: 'Select an Action',
        selectPhase: 'Select a phase',
        selectTrade: 'Select a trade',
        selectProcess: 'Select a %{companyProcessName}',
        selectPMPhase: 'Select a project management phase',
        selectSubPhase: 'Chose the subphase',
        selectXProcess: 'Select Process',
        selectTopic: 'Select a Topic',
        selectProject: 'Select a Project',
        selectTag: 'Select the Tags',
        selectResponsible: 'Select responsible',
        msUsers: 'Select Microsoft Users',
        newPassword: 'New Password',
        newLessonPlaceholder: '• Does this problem have cost or schedule consequences? \n\
• Does this lesson already exist in the knowledge database?\n\
• Is it a general (project management) or trade-specific issue? Which trade is primarily affected? \n\
• In which phase(s) must something be done to prevent the problem? \n\
• What question needs to be asked in order to become aware of the problem? \n\
• Quality Assurance: Does this question make sense to another person at this phase of a project?',
        newLessonTransferPlaceholder: '• Does this problem have cost or schedule consequences? \n\
• Is it a general (project management) or trade-specific issue? Which trade is primarily affected? \n\
• In which phase(s) must something be done to prevent the problem? \n\
• What question needs to be asked in order to become aware of the problem? \n\
• Quality Assurance: Does this question make sense to another person at this phase of a project?',
        chooseSubphase: 'Choose subphase',
        companyDescription: 'Please enter a brief description of the company',
        lessonLink: 'Example: https://www.example.com/',
        lessonSolution: 'Do you have a solution?',
        selectParentLesson: 'Should this lesson be assigned to an existing question? If yes, select a question',
    },
    messages: {
        logOutFirst: 'You need to logout first!',
        passwordRecoveryEmailHasBeenSent: 'Password recovery email has been sent',
        passwordChangedSuccessfully: 'Password changed successfully',
        AnErrorHasOccurredPleaseTryAgain: 'An error has occurred, please try again!',
        RecoveryEmailIsOnlyValidFor3Hours: 'Password recovery email is only valid for 3 hours!',
        thankYouEmailConfirmed: 'Thank you, your e-mail address has been confirmed!',
        youHaveSuccessfullyLoggedIn: 'You have Successfully logged In!',
        noChangesDetected: 'No changes detected!',
        changesSavedSuccessfully: 'Changes saved Successfully.',
        CompanyUsersRegisterLink: 'Company users register link:',
        LinkCopiedToClipboard: 'The following link has been copied to the clipboard: ',
        contactUsIfYouNeedHelp: 'Please contact us if you need help',
        areYouSureYouWantToDelete: 'Are you sure?',
        cloneLessons: 'Clone Lessons?',
        DataIsClonedFromMsg: 'Data is cloned from "AppEx GmbH"',
    },
    introMessages: {
        projectOverViewTradeTabIntroMessage: 'Here you create and edit phase-specific worksheets for the different trades selected for your project.',
        projectOverViewPMTabIntroMessage: 'Here you create and edit phase-specific worksheets for the project management topics selected for your project.',
        projectOverViewXTabIntroMessage: 'Here you create and edit %{companyProcessName}-specific worksheets',
        approvalListPageIntroMessage: 'All lessons which haven’t been approved yet by the Administrator are listed here.\n\
        The lessons can be edited and accepted or they can be deleted.',
        notificationsIntroMessage: 'Notifications intro messages',
        homeHowDoesAppexWork: '• In every project challenges lead to experiences. Some of these experiences lend themselves to lessons for future projects.<br/>\n\
• Employees document these experiences and convert them into lessons, which are worded as questions. These questions are assigned to the project phase in which they should be asked, in order to prevent future problems.<br/>\n\
• Employees create worksheets by selecting the relevant questions for their project from the database of knowledge. This ensures that experiences and lessons from past projects are applicable to new projects, both during the planning stage of a phase as well as during the quality control stage upon the completion of the phase.<br/>\n\
• Lessons are organized by trades or by project management topics, if they are general in nature or have the characteristics of a process.<br/>\n\
• Phases, trades, and project management topics can be created or modified by an Administrator.<br/>\n\
• Employees can create projects and assign to them team members, trades, and project phases. Employees can document the experiences in their projects and convert them into lessons for the knowledge database. Administrators can edit or approve these lessons.',
        StoreUpdateExperienceIntroMessage: 'Here you can record challenges or problems from your project in order to convert them into lessons for the knowledge database when it is convenient.',
        howToConnectToMSTeams: '\n\
        <p>\n\
                    Connecting AppEx to Microsoft will give you the ability to export projects and worksheets to\n\
                    Microsoft Teams and Planner.\n\
                </p>\n\
                <ul>\n\
                    <h6><li>How to Connect:</li></h6>\n\
                    <ul>\n\
                        <li>Sign in to Microsoft with an Admin account that have sufficient rights</li>\n\
                        <ul>\n\
                            <li>Recommendation: Use a dedicated Microsoft Admin account for AppEx</li>\n\
                        </ul>\n\
                        <li>\n\
                            On Microsoft grant page scroll down and check<b>"Consent on behalf of your organization"</b>\n\
                        </li>\n\
                        <li>Connection to Microsoft will be established</li>\n\
                    </ul>\n\
                    <h6><li>How to Revoke:</li></h6>\n\
                    <ul>\n\
                        <li>Click revoke</li>\n\
                        <li>On confirmation modal click <b>Yes</b></li>\n\
                        <li>Connection to Microsoft will be automatically deleted</li>\n\
                        <li><b class="has-text-danger">To reconnect again wait 30 minutes!</b></li>\n\
                    </ul>\n\
                    <h6><li>Be aware of following:</li></h6>\n\
                    <ul>\n\
                        <li>\n\
                            Teams, Plans, Tasks and all other resources on\n\
                            Microsoft will be created on behalf of the\n\
                            Microsoft Admin who granted AppEx the rights to connect to Microsoft.\n\
                        </li>\n\
                        <li>\n\
                            If there are any projects with integration to Microsoft teams enabled, Do not revoke the\n\
                            connection or change the Microsoft Admin who granted AppEx the rights to connect to\n\
                            Microsoft.\n\
                        </li>\n\
                        <li>The process to create Microsoft Teams from Projects can take up to few hours.</li>\n\
                        <li>\n\
                            Do not change the permissions or the roles of the Microsoft Admin who granted AppEx the\n\
                            rights to connect to Microsoft.\n\
                        </li>\n\
                    </ul>\n\
                </ul>\n\
        ',
    },
    emptyMessages: {
        noProjectMessageHeader: 'No project created yet',
        noProjectMessageBody: 'Please create a project first (top right corner)',
        noLessonMessageHeader: 'No lesson created yet.',
        noLessonMessageBody: 'Please add a lesson first',
        allLessonsAccepted: 'Currently all lessons are approved',
        noExperienceHeader: 'No experiences yet',
        noExperienceBody: 'Document a problem or a challenge above. You can also note a possible question and further detail it later.',
        noEntryHeader: 'No entries found',
        noEntryBody: 'Unfortunately there are no entries here.',
        noTradeOpenTasksHeader: '',
        noTradeOpenTasksBody: 'This person has no open tasks for the selected phases and trades.',
        noPmOpenTasksHeader: '',
        noPmOpenTasksBody: 'This person has no open tasks for the selected phases.',
        noXOpenTasksBody: 'This person has no open tasks for the selected %{companyProcessName}.',
        msIntegrationHeader: 'Microsoft integration still pending',
        msIntegrationBody: 'While Microsoft integration is still pending, worksheets can not be created',
        projectEditDisabledHeader: 'Project edit disabled for the project "{0}"',
        projectEditDisabledBody: 'If Microsoft connection is revoked project can\'t be edited. Restore Microsoft connection to activate the project',
    },
    confirmRemoveMessages: {
        confirmDelete: 'Please type <span class="has-text-weight-semibold has-text-danger">"{0}"</span> to proceed or close this modal to cancel.',
        confirmDeleteMicrosoftTeam: 'Microsoft Team (and all related resources) associated with this project will also be deleted.',
        trade: {
            header: 'You are going to remove "{0}" trade. Removed trades CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the trade will delete its lessons and all dependant data including worksheets, applied lessons and etc.',
        },
        pmPhase: {
            header: 'You are going to remove "{0}" PM phase. Removed PM phases CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the PM phase will delete its subphases, lessons and all dependant data including worksheets, applied lessons and etc.',
        },
        pmSubPhase: {
            header: 'You are going to remove "{0}" PM Sub phase. Removed PM Sub phases CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the PM Sub phase will delete its lessons and all dependant data including worksheets, applied lessons and etc.',
        },
        xProcess: {
            header: 'You are going to remove "{0}" X Process. Removed X Processes CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the X Process will delete its x sub process, lessons and all dependant data including worksheets, applied lessons and etc.',
        },
        xSubProcess: {
            header: 'You are going to remove "{0}" X Sub Process. Removed X Sub Processes CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the X Sub Process will delete its lessons and all dependant data including worksheets, applied lessons and etc.',
        },
        projectDelete: {
            header: 'You are going to remove "{0}" Project. Removed Projects CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the Project will delete its worksheets and all dependant data including applied lessons and etc.',
        },
        projectUpdate: {
            header: 'You are about to remove some entities from "{0}" Project. Removed entities CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'List of entities which will be removed:',
        },
        topic: {
            header: 'You are going to remove "{0}" Topic. Removed Topics CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the Topic will delete all its dependant lessons',
        },
        phase: {
            header: 'You are going to remove "{0}" Phase. Removed Phases CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the Phase will delete all its dependant lessons',
        },
        worksheet: {
            header: 'You are going to remove this Worksheet from "{0}" project. Removed Worksheets CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'All entries will be deleted too.',
        },
        pmWorksheet: {
            header: 'You are going to remove this Worksheet from "{0}" project. Removed Worksheets CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'All entries will be deleted too.',
        },
        users: {
            header: 'You are going to delete the following users',
            body: 'All of their data (Projects, applied lessons, lessons, experiences, worksheets and Global Topics) will be deleted too unless you assign them to another user!',
        },
        company: {
            header: 'You are deleting <span class="has-text-weight-semibold has-text-danger">"{0}"</span> company!',
            body: 'All of their data (Projects, applied lessons, lessons, experiences, worksheets, Global Topics, Users and etc) will be deleted too!',
        },
        tag: {
            header: 'You are going to remove "{0}" Tag. Removed Tags CANNOT be restored! Are you ABSOLUTELY sure?',
            body: 'Removing the Tag will remove it from all lessons',
        },
    },
    toastMessages: {
        delete: {
            generic: 'The {x} was successfully deleted',
            lesson: 'The lesson was successfully deleted',
            trade: 'The trade was successfully deleted',
            topic: 'The topic was successfully deleted',
            phase: 'The phase was successfully deleted',
            pmPhase: 'The phase was successfully deleted',
            pmSubPhase: 'The subphase was successfully deleted',
            experience: 'The experiences was successfully deleted',
            worksheet: 'The worksheet was successfully deleted',
            pmWorksheet: 'The worksheet was successfully deleted',
            tag: 'The tag was successfully deleted',
        },
        store: {
            generic: 'The {x} was successfully stored',
            lesson: 'The lesson was successfully stored',
            trade: 'The trade was successfully stored',
            topic: 'The topic was successfully stored',
            phase: 'The phase was successfully stored',
            pmPhase: 'The phase was successfully stored',
            pmSubPhase: 'The subphase was successfully stored',
            dynamicField: 'The attribute was saved successfully',
            worksheet: 'The worksheet was successfully stored',
            experience: 'The lesson was successfully saved and deleted from the experiences',
            cloningSuccessful: 'The data were correctly transmitted',
            email: 'The email was successfully sent',
            tag: 'The tag was successfully stored',
        },
        update: {
            generic: 'The {x} was successfully updated',
            account: 'The account was successfully updated',
            lesson: 'The lesson was successfully updated',
            trade: 'The trade was successfully updated',
            topic: 'The topic was successfully updated',
            phase: 'The phase was successfully updated',
            pmPhase: 'The phase was successfully updated',
            pmSubPhase: 'The subphase was successfully updated',
            dynamicField: 'The attribute was successfully updated',
            worksheet: 'The worksheet was successfully updated',
            tag: 'The tag was successfully updated',
            emailedOpenTasks: 'Emails sent successfully',
        },
        error: {
            worksheet: 'There was an error updating the Worksheet',
            cannot_load_appliedLessons: 'Could not load the Lessons',
            cannot_remove_worksheet: 'Could not remove the Worksheet.',
            cloningError: 'There was an error on cloning data, please try again later',
            lesson: 'Could not remove the Lesson.',
            error: 'An Error occured',
        },
    },
    navigation: {
        switcher: {
            changeTo: 'Switch to',
            native: {
                name: 'AppEx',
                description: 'Knowledge and Projects',
            },
            orders: {
                name: 'Orders',
                description: 'Manage Delivery Objects',
            },
            loading: 'Opening',
        },
        main: {
            objects: 'My Projects',
            reports: 'Todo',
            experiences: 'My Experiences',
            approval: 'New Knowledge',
            notifications: 'Notifications',
            setup: 'Knowledge',
            system: 'Admin',
            register: 'Sign up',
            login: 'Login',
            logout: 'Logout',
        },
    },
    notificationMessages: {
        applied_lesson_stored: 'added a question to worksheet of trade: <b>{0}</b> and phase: <b>{1}</b>',
        pm_applied_lesson_stored: 'added a question to <b>{0}</b>',
        x_applied_lesson_stored: 'added a question to <b>{1}</b>',
        project_stored: 'created project <b>{0}</b>',
        project_updated: 'edited project <b>{0}</b>',
        project_deleted: 'deleted project <b>{0}</b>',
        worksheet_stored: 'created a worksheet for trade: <b>{0}</b> and phase: <b>{1}</b>',
        worksheet_edited: 'edited worksheet of trade: <b>{0}</b> and phase: <b>{1}</b>',
        worksheet_deleted: 'deleted worksheet of trade: <b>{0}</b> and phase: <b>{1}</b>',
        pm_worksheet_stored: 'created PM worksheet <b>{0}</b>',
        pm_worksheet_edited: 'edited PM worksheet <b>{0}</b>',
        pm_worksheet_deleted: 'deleted PM worksheet <b>{0}</b>',
    },
    integrations: {
        introduction: 'Integrations allow you to make third-party applications part of your AppEx workflow.',
    },
    orders: {
        title: 'Order',
        phases: 'PM Phases',
        deliveryObjectCompletionPercentage: 'Delivery Objects %',
        bimTargetCompletionPercentage: 'BIM Targets %',
        bimUseCaseCompletionPercentage: 'BIM Use Cases %',
        link: 'Link',
    },
};

export default en;